import React from 'react';
import { Search, MapPin } from 'lucide-react';
export function HeroSection() {
  return <div className="relative overflow-hidden bg-[#0B0B0B] text-white pt-28 pb-36 px-4 sm:px-6 lg:px-8" data-id="element-740">
      {/* Background image — visible and vibrant */}
      <img src="https://cdn.magicpatterns.com/uploads/1UWX3upNAeRHGAGLj3nnFR/WhatsApp_Image_2026-03-20_at_13.12.53.jpg" alt="Los Santos" className="absolute inset-0 w-full h-full object-cover" data-id="element-741" />

      {/* Layered overlays — image stays visible, text stays readable */}
      {/* Bottom-heavy gradient: dark at bottom for search bar, transparent at top for image */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0B] via-[#0B0B0B]/60 to-transparent" data-id="element-742" />
      {/* Top vignette for headline readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0B0B]/50 via-transparent to-transparent" data-id="element-743" />
      {/* Center radial for text contrast without killing the image */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'radial-gradient(ellipse at 50% 50%, rgba(11,11,11,0.55) 0%, transparent 70%)'
    }} data-id="element-744" />

      <div className="relative max-w-4xl mx-auto text-center z-10" data-id="element-745">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight mb-6 leading-tight" data-id="element-746">
          <span className="text-white" style={{
          textShadow: '0 2px 20px rgba(0,0,0,0.5)'
        }} data-id="element-747">
            El marketplace gastronómico de
          </span>
          <br data-id="element-748" />
          <span className="text-[#C9A34E]" style={{
          textShadow: '0 2px 30px rgba(201,163,78,0.4)'
        }} data-id="element-749">
            Los Santos
          </span>
        </h1>
        <p className="text-lg sm:text-xl text-white/80 mb-10 max-w-2xl mx-auto font-medium" style={{
        textShadow: '0 1px 10px rgba(0,0,0,0.5)'
      }} data-id="element-750">
          Descubre, ordena y disfruta de los mejores restaurantes de la zona en
          un solo lugar.
        </p>

        {/* Search Bar — semi-transparent dark glass look */}
        <div className="bg-[#0B0B0B]/80 border border-white/15 p-2 rounded-2xl sm:rounded-full shadow-lg max-w-3xl mx-auto flex flex-col sm:flex-row items-center gap-2" data-id="element-751">
          <div className="flex-1 w-full flex items-center px-4 py-2 border-b sm:border-b-0 sm:border-r border-white/10" data-id="element-752">
            <MapPin className="w-5 h-5 text-[#C9A34E]/70 mr-3 shrink-0" data-id="element-753" />
            <select className="w-full bg-transparent text-white focus:outline-none appearance-none cursor-pointer font-medium" data-id="element-754">
              <option value="" className="bg-[#141414]" data-id="element-755">
                Todas las zonas
              </option>
              <option value="san-marcos" className="bg-[#141414]" data-id="element-756">
                San Marcos
              </option>
              <option value="santa-maria" className="bg-[#141414]" data-id="element-757">
                Santa María
              </option>
              <option value="dota" className="bg-[#141414]" data-id="element-758">
                Dota
              </option>
            </select>
          </div>

          <div className="flex-1 w-full flex items-center px-4 py-2" data-id="element-759">
            <Search className="w-5 h-5 text-white/40 mr-3 shrink-0" data-id="element-760" />
            <input type="text" placeholder="¿Qué se te antoja hoy?" className="w-full bg-transparent text-white focus:outline-none placeholder:text-white/30" data-id="element-761" />
          </div>

          <button className="w-full sm:w-auto bg-[#C9A34E] text-[#0B0B0B] font-bold rounded-xl sm:rounded-full px-8 py-3 shrink-0 hover:bg-[#d4b365] transition-colors active:scale-95" data-id="element-762">
            Buscar
          </button>
        </div>
      </div>
    </div>;
}